/* PagingScheduleActivityFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

// mongo db query to filter empty objects
const mongoDbQuery = {
    $or: [
        {
            activityType: "create"
        },
        {
            $and: [
                { activityType: "update" },
                {
                    patch: {
                        $elemMatch: {
                            $or: [
                                { $and: [{ path: "/status" }, { value: { $exists: true } }] },
                                {
                                    $and: [{ path: "/nextExecutionTime" }, { value: { $exists: true } }]
                                }
                            ]
                        }
                    }
                }
            ]
        },
        {
            activityType: "trigger"
        }
    ]
};

class PagingScheduleActivityFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedAuditsFeed(mongoDbQuery, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(this._userSession.activeOrganization.id, mongoDbQuery, this._entityFields, this._sort);
    }

    _feedShutDown() {
        return this._EntityDef.stopRelatedAuditsFeed();
    }
}

module.exports = PagingScheduleActivityFeed;
